/**
 * Pins a hostname to one tenant subtree. `NUXT_PUBLIC_TENANT_HOSTS` is a
 * comma-separated list of `host=tenantPath`, e.g.
 * `nevsehir.su.una.center=nevsehir`. On a pinned host the app only offers that
 * tenant and its descendants; on any other host, every tenant the user has.
 *
 * This scopes what the UI offers, not what the API allows: access is still
 * decided by the user's `user_tenants` rows on the server.
 */
export function hostTenantPath(): string | null {
  if (!import.meta.client) return null
  const raw = (useRuntimeConfig().public.tenantHosts as string | undefined) || ''
  const host = window.location.hostname.toLowerCase()
  for (const entry of raw.split(',')) {
    const [entryHost, path] = entry.split('=').map(part => part?.trim())
    if (entryHost && path && entryHost.toLowerCase() === host) return path
  }
  return null
}

export function visibleTenants<T extends { tenantPath: string }>(tenants: T[] = []): T[] {
  const pinned = hostTenantPath()
  if (!pinned) return tenants
  return tenants.filter(t => t.tenantPath === pinned || t.tenantPath.startsWith(`${pinned}.`))
}
